import React from 'react';
import ActionMenu from '../../../common/action/ActionMenu';
import { ListCell } from '../../../common/cells/ListCell';
import StatusCell from '../../../common/cells/StatusCell';
import { MultiSelectFilterFn } from '../../../common/filters/Filters';
import MultiSelectColumnFilter from '../../../common/filters/MultiSelectColumnFilter';
import StateMultiSelectColumnFilter, { StateMultiSelectFilterFn } from '../../../common/filters/StateMultiSelectColumnFilter';
import TextColumnFilter from '../../../common/filters/TextColumnFilter';

export const columns = (refresh) => {
    return [
        {
            Header: 'Státusz',
            accessor: 'stateLabel',
            id: 'stateLabel',
            show: true,
            className: 'status',
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
            Cell: props => <StatusCell row={props.row.original} />,
        },
        {
            Header: 'Partner',
            accessor: 'name',
            id: 'name',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Típus',
            accessor: 'partnerTypeLabel',
            id: 'partnerTypeLabel',
            show: true,
            className: 'idColumn center',
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
        },
        {
            Header: 'Jelenlegi Bankszámlaszám',
            accessor: 'currentBankAccountNumbers',
            id: 'currentBankAccountNumbers',
            className: 'bankAccountNumberColumn',
            show: true,
            Cell: props => <ListCell cell={props} delimiter=', ' />,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Jelenlegi Adószám',
            accessor: 'currentTaxNumber',
            id: 'currentTaxNumber',
            show: true,
            className: 'taxNumberColumn',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Jelenlegi Cím',
            accessor: 'currentAddress',
            id: 'currentAddress',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Megjegyzés',
            accessor: 'comment',
            id: 'comment',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'customer'} refresh={refresh} />,
            id: 'menu',
            className: 'actions',
            show: true,
        },
    ]
}